<div class="cell auto grid-y align-center align-middle cell-block-y playerClosure">
    <a class="button secondary hollow playerClosure-back" [routerLink]="'/sessions/decisions'">
        <i class="fas fa-arrow-left"></i> <span [i18nKey]="'action.back.to.decisions'"></span>
    </a>

    <h2 class="cell shrink playerClosure-title">
        <span [i18nKey]="'player.decisions.closure.title'"></span>
        <p class="period-info">
            <kiwi-period [period]="period" *ngIf="period"></kiwi-period>
        </p>
    </h2>

    <kiwi-spacer [size]="48"></kiwi-spacer>
    <ng-container *ngIf="statusData">
        <div class="playerClosure-illu"></div>
        <div class="cell shrink playerClosure-content"
             *ngIf="statusData.currentStatus === 'OPENED'; else decisionsClosed">
            <h2 class="playerClosure-content-title"[i18nKey]="'player.decisions.closure.subtitle.not.closed'"></h2>
            <p class="playerClosure-content-description"
               [innerHTML]="'player.decisions.closure.description.not.closed'|translate" [i18nKey]="[{target: 'innerHTML', key: 'player.decisions.closure.description.not.closed'}]"></p>
            <button (click)="closeDecision()" class="button _primary"[i18nKey]="'player.decisions.closure.close'"></button>
        </div>

        <ng-template #decisionsClosed>
            <div class="playerClosure-content">
                <h2 class="playerClosure-content-title"[i18nKey]="'player.decisions.closure.subtitle.closed'"></h2>
                <p class="playerClosure-content-description"><span [i18nKey]="'player.decisions.closure.decisions.closed'"></span>
                    <span *ngIf="statusData.teamClosureLog">
                    {{statusData.teamClosureLog.date | date:'short':'':'fr-FR'}}
                    <span [i18nKey]="'player.decisions.closure.closed.by.player'"></span>
                    <strong>{{statusData.teamClosureLog.firstName}} {{statusData.teamClosureLog.lastName}}</strong>
                        </span>
                    <span *ngIf="statusData.teamClosureLog && statusData.animatorClosureLog"[i18nKey]="'player.decisions.closure.and.on'"></span>

                    <span *ngIf="statusData.animatorClosureLog">
                        {{statusData.animatorClosureLog.date | date:'short':'':'fr-FR'}}
                    <span [i18nKey]="'player.decisions.closure.closed.by.animator'"></span>
                    <strong>{{statusData.animatorClosureLog.firstName}} {{statusData.animatorClosureLog.lastName}}</strong></span>.
                    <span *ngIf="statusData.animatorClosureLog && statusData.teamClosureLog; else closedInfos"[i18nKey]="'player.decisions.closure.decisions.simulation'"></span>
                    <ng-template #closedInfos [i18nKey]="'player.decisions.closure.decisions.closed.infos'"></ng-template>
                </p>

                <button (click)="cancelClosure()" class="button _cancel"
                        *ngIf="!statusData.animatorClosureLog"[i18nKey]="'player.decisions.closure.cancel.closure'"></button>
            </div>
        </ng-template>
    </ng-container>
</div>
